import React from 'react'

//example of a functional component
const NotFoundPage = () => <div id="not-found-page" className="flex-centered max-width">
        You are attempting to access a page that you do not have access to or that doesn't exist. 
        Please contact your adminstrator for further assistance. 
    </div>

export default NotFoundPage